import React from 'react';
import {Star, Quote} from 'lucide-react';

interface TestimonialCardProps {
  name: string;
  city: string;
  bloodType: string;
  testimonial: string;
  rating: number;
  image?: string;
}

export function TestimonialCard({ name, city, bloodType, testimonial, rating, image }: TestimonialCardProps) {
  return (
    <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
      <div className="flex items-start mb-6">
        <Quote className="h-10 w-10 text-[#E53E3E] opacity-20 mr-4 flex-shrink-0" />
        <div className="flex-1">
          <div className="flex mb-3">
            {[...Array(5)].map((_, i) => (
              <Star
                key={i}
                className={`h-5 w-5 ${
                  i < rating ? 'text-yellow-400 fill-current' : 'text-gray-300'
                }`}
              />
            ))}
          </div>
          <p className="text-gray-700 leading-relaxed italic mb-6">
            "{testimonial}"
          </p>
        </div>
      </div>
      <div className="flex items-center pt-6 border-t border-gray-100">
        <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#E53E3E] to-red-600 flex items-center justify-center text-white font-bold text-lg mr-4">
          {bloodType}
        </div>
        <div>
          <p className="font-bold text-gray-900">{name}</p>
          <p className="text-sm text-gray-500">{city}</p>
        </div>
      </div>
    </div>
  );
}
